import { render, staticRenderFns } from "./RuleLook.vue?vue&type=template&id=57fe3867&scoped=true"
import script from "./RuleLook.vue?vue&type=script&lang=js"
export * from "./RuleLook.vue?vue&type=script&lang=js"
import style0 from "./RuleLook.vue?vue&type=style&index=0&id=57fe3867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fe3867",
  null
  
)

export default component.exports